import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import AboutUs from './views/about-us'
import Cases from './views/cases'
import SocialRecruitingBeratung from './views/social-recruiting-beratung'
import SocialMediaRecruitingKampagnen from './views/social-media-recruiting-kampagnen'
import EmployerBranding from './views/employer-branding'
import ActiveSourcing from './views/active-sourcing'
import RecruitingAdsManagement from './views/recruiting-ads-management'
import Impressum from './views/impressum'
import Datenschutz from './views/datenschutz'
import AGB from './views/agb'
import Disclaimer from './views/disclaimer'
import NotFound from './views/not-found'

// ScrollToTop component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={AboutUs} exact path="/ueber-uns" />
        <Route component={Cases} exact path="/cases" />
        <Route component={SocialRecruitingBeratung} exact path="/social-recruiting-beratung" />
        <Route component={SocialMediaRecruitingKampagnen} exact path="/social-media-recruiting-kampagnen" />
        <Route component={EmployerBranding} exact path="/employer-branding" />
        <Route component={ActiveSourcing} exact path="/active-sourcing" />
        <Route component={RecruitingAdsManagement} exact path="/recruiting-ads-management" />
        <Route component={Impressum} exact path="/impressum" />
        <Route component={Datenschutz} exact path="/datenschutz" />
        <Route component={AGB} exact path="/agb" />
        <Route component={Disclaimer} exact path="/disclaimer" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

const container = document.getElementById('app')
const root = createRoot(container)
root.render(<App />)
